import { Component, Input, OnInit } from '@angular/core';
import { Priority } from 'projects/admin/src/app/features/verification-tasks/models/TaskDetails';
import { TaskPriorityEnumValues } from '../../../models/verification-tasks/enums/TaskPriorityEnumValues';

@Component({
  selector: 'app-verification-task-priority',
  standalone: false,
  templateUrl: './verification-task-priority.component.html'
})
export class VerificationTaskPriorityComponent implements OnInit {

  @Input({ required: true }) priority: Priority;
  priorityEnum = TaskPriorityEnumValues;

  constructor() { }

  ngOnInit() {
  }

}
